export default __webpack_public_path__ + "static/media/help-icon.cd7bb4fb.svg";